import { PartnerOrganizationView } from "@/components/partner/PartnerViews";

const PartnerOrganization = () => <PartnerOrganizationView />;

export default PartnerOrganization;
